module.exports = __webpack_public_path__ + "static/media/vf-program.5a395397.png";